import { actions } from "redux-store";
import { EventTypes } from "redux-store/slices/events/events.interfaces";
import { useDispatch } from "react-redux";

export const useChooseLevelPage = () => {
  const dispatch = useDispatch();

  dispatch(
    actions.dispatchEvent({
      eventType: EventTypes.QUIZ_VIEW,
      extraData: { quizStepName: "Choose level page" },
    }),
  );

  return {};
};
